<template>
    <div class="uploaded-file">
        <img v-if="typeFile === 'excel'" src="@/assets/employee/uploaded-excel.png">
        <img v-else-if="typeFile === 'zip'" src="@/assets/employee/uploaded-zip.png">
        <div class="mt-5 d-flex">
            <div class="uploaded-detail">
                <div class="d-flex-between">
                    <div class="uploaded-file-name">
                        {{ name }}
                    </div>
                    <div>
                        {{ loadingPercent }} %
                    </div>
                </div>
                <v-progress-linear
                    class="mt-2"
                    rounded
                    :color="colorProgress"
                    height="10"
                    :value="loadingPercent" />
            </div>
            <div class="ml-4 mt-6">
                <transition name="fade">
                    <i  v-if="loadingPercent === 100"
                        :class="classIcon" />
                </transition>
                <transition name="fade">
                    <i  v-if="loadingPercent !== 100"
                        :class="typeFile"
                        class="file-loading fad fa-spinner-third" />
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UploadFile',

    props: {
        name: {
            type: String,
            default: ''
        },

        loadingPercent: {
            type: Number,
            default: 100
        },

        isSuccess: {
            type: Boolean,
            default: true
        },

        typeFile: {
            type: String,
            default: ''
        }
    },

    computed: {
        classIcon () {
            if (this.isSuccess === true) {
                return 'success-loading fas fa-check-circle'
            } else {
                return 'error-loading fas fa-exclamation-circle'
            }
        },

        colorProgress () {
            if (this.isSuccess === true && this.typeFile === 'excel') {
                return '#139888'
            } else if (this.isSuccess === true && this.typeFile === 'zip') {
                return '#6c98ba'
            } else {
                // for upload fail
                return '#ff544a'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.uploaded-detail {
    width: 390px;
}
.uploaded-file-name {
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.file-loading {
    font-size: 20px;
    animation: spin 2s linear infinite;
}
.excel {
    color: #139888;
}
.zip {
    color: #6c98ba;
}
.success-loading {
    font-size: 20px;
    color: #58df00;
}
.error-loading {
    font-size: 20px;
    color: #ff544a;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.uploaded-file {
    display: flex;
}
.fade-enter-active {
  transition: opacity .5s ease-out;
}
.fade-enter, .fade-leave-to, .fade-leave-active {
  opacity: 0;
}
.success-progress {
    color: #139888;
}
.error-progress {
    color: #ff544a;
}
</style>
